import {
  BoostProvider,
  BoostTask,
  PROVIDERS as BOOST_PROVIDERS,
} from '../types/boost';
import createAdHandler from 'monetag-tg-sdk';

export const PROVIDERS = {
  ...BOOST_PROVIDERS,
  MONETAG: 'monetag',
} as const;

interface MonetagAdEvent {
  reward_event_type: 'valued' | string;
}

export class MonetagBoostProvider implements BoostProvider {
  private adHandler: () => Promise<MonetagAdEvent>;

  constructor() {
    console.log('[MonetagBoostProvider] constructor: инициализация провайдера');
    this.adHandler = createAdHandler(
      9421495,
    ) as unknown as () => Promise<MonetagAdEvent>;
  }

  getName(): string {
    console.log('[MonetagBoostProvider] getName вызван');
    return PROVIDERS.MONETAG;
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    console.log('[MonetagBoostProvider] getAvailableTasks вызван');
    try {
      return [
        {
          id: 'monetag-1',
          title: 'Просмотреть рекламумонектег',
          description: 'Посмотрите рекламу Monetag для получения буста',
          provider: this.getName(),
          onClick: async () => {
            try {
              const event = await this.adHandler();
              if (event.reward_event_type === 'valued') {
                return 'success';
              } else {
                return 'ads_not_found';
              }
            } catch (error) {
              return 'ads_not_found';
            }
          },
        },
      ];
    } catch (error) {
      console.error(
        '[MonetagBoostProvider] Ошибка получения заданий Monetag:',
        error,
      );
      return [];
    }
  }
}
